import { Controller } from "@hotwired/stimulus";

/**
 * Pré-remplit les tarifs dérivés d'une formule de transport.
 *
 * Les zones de transport calculaient le trimestriel (mensuel × 3) et
 * l'annuel (mensuel × 10 — dix mois d'année scolaire) toutes seules :
 * l'école ne tapait qu'un nombre. Les formules ne portent pas cette règle,
 * et c'est volontaire — une pension d'internat trimestrielle n'est pas trois
 * mensualités, un forfait annuel de garderie n'est pas dix mois.
 *
 * Le confort est donc rendu ici, à la saisie, et seulement pour le
 * transport : les deux champs se remplissent et restent modifiables. Dès que
 * l'école en corrige un, il n'est plus recalculé.
 */
export default class extends Controller {
  static targets = ["monthly", "quarterly", "annual"];
  static values = {
    quarterlyFactor: { type: Number, default: 3 },
    annualFactor: { type: Number, default: 10 },
  };

  connect() {
    this.computed = { quarterly: null, annual: null };
  }

  monthlyChanged() {
    const monthly = parseFloat(this.monthlyTarget.value);
    if (Number.isNaN(monthly)) return;

    this.fill("quarterly", Math.round(monthly * this.quarterlyFactorValue));
    this.fill("annual", Math.round(monthly * this.annualFactorValue));
  }

  // Ne remplit que ce que l'école n'a pas saisi elle-même : un champ vide, ou
  // un champ qui porte encore la valeur qu'on y avait mise.
  fill(name, value) {
    if (!this[`has${name[0].toUpperCase()}${name.slice(1)}Target`]) return;

    const field = this[`${name}Target`];
    const untouched = field.value === "" || field.value === String(this.computed[name]);
    if (!untouched) return;

    field.value = value;
    this.computed[name] = value;
  }
}
